import _ from "underscore";
import { EQ, GTE, LTE } from "../framework/query";
import M from "../strings";
import { DateTime, Number, Select, Text } from "../web/components/forms";
import * as datasource from "../utils/datasource";
import { optional } from "../utils/lang";

export const SEARCH_FORM_CODE_DESCRIPTOR = (option) => {
    let controlType = optional(option, {}).isNumberCode ? Number : Text
    return {
        showInCard: false,
        fields: [
            {
                property: "code",
                label: M("value"),
                control: controlType,
                filterType: "eq",
            },
        ]
    }
}

export const SEARCH_FORM_DATE_DESCRIPTOR = (propertyName) => _.assign({}, {
    showInCard: false,
    fields: [
        {
            property: propertyName,
            label: M("value"),
            control: DateTime,
        },
        {
            property: "_filterType",
            label: M("filterType"),
            control: Select,
            props: {
                allowNull: false,
                datasource: datasource.fixed([
                    {label: M("FILTER_GTE"), value: GTE},
                    {label: M("FILTER_LTE"), value: LTE}
                ])
            }
        }
    ]
})

export const SEARCH_FORM_NUMBER_DESCRIPTOR = (propertyName) => _.assign({}, {
    showInCard: false,
    fields: [
        {
            property: propertyName,
            label: M("value"),
            control: Number,
        },
        {
            property: "_filterType",
            label: M("filterType"),
            control: Select,
            props: {
                allowNull: false,
                datasource: datasource.fixed([
                    {label: M("FILTER_EQ"), value: EQ},
                    {label: M("FILTER_GTE"), value: GTE},
                    {label: M("FILTER_LTE"), value: LTE}
                ])
            }
        }
    ]
})

